import React from 'react';
import { DynamicSectionRenderer } from '../DynamicSectionRenderer';

/**
 * StartupTaskDetail - Contract-Driven Startup Review Renderer  
 * Authority: Law 65.1 + Law 66.1 (No hard-coded labels)
 */

const FALLBACK_CONFIG = {
    sections: [
        { field: "description", label: null, render_type: "text", required: true },
        { field: "rationale", label: "Assessment", render_type: "callout", required: false },
        { field: "verdict", label: "Recommendation", render_type: "verdict", required: false }
    ]
};

export function StartupTaskDetail({ item, uiConfig }) {
    const renderConfig = uiConfig || FALLBACK_CONFIG;

    if (!renderConfig || !renderConfig.sections) {
        return <ContractText variant="caption" className="text-muted-foreground">No render configuration available</ContractText>;
    }

    return <DynamicSectionRenderer sections={renderConfig.sections} item={item} />;
}
